/**
 * Sets a cookie with the given name, value, domain and expiration time
 *
 * @param {string} name - The name of the cookie
 * @param {string} value - The value of the cookie
 * @param {number} days - The number of days until the cookie expires
 * @param {string} [domain] - Optional domain for the cookie (use "root" domain with . prefix for cross-subdomain support)
 */
export function setCookie(name, value, days, domain) {
  let expires = '';
  if (days) {
    const date = new Date();
    date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
    expires = `; expires=${date.toUTCString()}`;
  }

  let domainPart = '';
  if (domain) {
    domainPart = `; domain=${domain}`;
  }

  document.cookie = `${name}=${value}${expires}${domainPart}; path=/`;
}

/**
 * Gets a cookie by name
 *
 * @param {string} name - The name of the cookie to retrieve
 * @returns {string|null} - The cookie value or null if not found
 */
export function getCookie(name) {
  const nameEQ = `${name}=`;
  const ca = document.cookie.split(';');

  for (let i = 0; i < ca.length; i += 1) {
    let c = ca[i];
    while (c.charAt(0) === ' ') c = c.substring(1, c.length);
    if (c.indexOf(nameEQ) === 0) return c.substring(nameEQ.length, c.length);
  }

  return null;
}

/**
 * Deletes a cookie by name
 *
 * @param {string} name - The name of the cookie to delete
 * @param {string} [domain] - Optional domain for the cookie (use "root" domain with . prefix for cross-subdomain support)
 */
export function deleteCookie(name, domain) {
  let domainPart = '';
  if (domain) {
    domainPart = `; domain=${domain}`;
  }

  document.cookie = `${name}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/${domainPart}`;
}
